import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconBuilderDashboard(props: SvgIconProps) {
  return (
    <SVGIcon xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <path
        fill="currentColor"
        d="m13.707 6.793-5-5a1 1 0 0 0-1.414 0l-5 5A1 1 0 0 0 2 7.5v6a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-6a1 1 0 0 0-.293-.707M13 13H3V7.5l5-5 5 5z"
      />
    </SVGIcon>
  );
}
